import { useIntl } from "react-intl";
import EmailBlockTypeEnum from "../../../../models/EmailBlockTypeEnum";
import { blockIconClass, blockLabelKey } from "../../../../services/EmailDocumentUtils";

type Props = {
    blockTypes: EmailBlockTypeEnum[];
    /** Types hidden for account-scoped templates. */
    orderOnlyBlockTypes: EmailBlockTypeEnum[];
    scope: "order" | "account";
    onAdd: (type: EmailBlockTypeEnum) => void;
    disabled?: boolean;
};

/** Buttons that append a new block of each type to the document. */
const BlockPalette = (props: Props) => {
    const intl = useIntl();

    return (
        <div className={"BlockPalette"}>
            {props.blockTypes.map((type) => {
                const orderOnly = props.orderOnlyBlockTypes.includes(type);

                if (orderOnly && props.scope !== "order") {
                    return null;
                }

                return (
                    <button
                        key={type}
                        type={"button"}
                        className={"btn btn-sm btn-outline-secondary"}
                        disabled={props.disabled}
                        onClick={() => props.onAdd(type)}
                        data-testid={`add-block-${type}`}>
                        <i className={`${blockIconClass(type)} me-1`} aria-hidden={true} />
                        {intl.formatMessage({ id: blockLabelKey(type) })}
                    </button>
                );
            })}
        </div>
    );
};

export default BlockPalette;
